import { useQuery } from "@tanstack/react-query";

import { tcTechnicalSummaryService } from "../services/tcTechnicalSummary.service";

export function useTcTechnicalSummaryEligibility(caseId?: string) {
  return useQuery({
    queryKey: ["tc-technical-summary-eligibility", caseId],
    queryFn: () => tcTechnicalSummaryService.getEligibility(caseId as string),
    enabled: Boolean(caseId),
    staleTime: 30000,
  });
}
